import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavBar, {
      currentPage: _ctx.currentView,
      onChangeView: _ctx.changeView
    }, null, 8, ["currentPage", "onChangeView"]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentView), { onExplorePage: _ctx.exploreDestination }, null, 40, ["onExplorePage"]))
  ], 64))
}